// extracted by mini-css-extract-plugin
export default {"tabs":"g0_g1","tabs_isOneWidth":"g0_ha","tabs__header__item":"g0_hb","tabs_game":"g0_hc","tabs__header":"g0_he","tabs__content":"g0_hf","tabs__header__item_active":"g0_hg"};